<template>
    <div>
        <h1>Page not found</h1>
        <p>This page does not exist.</p>
    </div>
</template>
